export const NOTIFY_SUCCESS = "NOTIFY_SUCCESS";

export const NOTIFY_ERROR = "NOTIFY_ERROR";

export const NOTIFY_WARNING = "NOTIFY_WARNING";

export const SUCCESS = "SUCCESS";

export const ERROR = "ERROR";

export const WARNING = "WARNING";



// WEBPACK FOOTER //
// ./src/types/notificationTypes.js